<script>
import app from 'app';

export default {
  props: {
    placeholder: {
      type: String,
    },
    resetOnBlur: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      default: 'wt2-text-l',
    },
    disableInput: {
      type: Boolean,
      default: false,
    },
    acDisabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      tempValue: this.value,
      highlight: this.value,
      showAutoComplete: false,
      focused: false,
      activeRowIndex: null,
      touched: false,
    };
  },

  computed: {
    showResultsPanel() {
      return (
        this.touched &&
        this.focused &&
        !this.disabled &&
        this.allSuggestions.length
      );
    },
  },

  watch: {
    focused(newVal) {
      if (newVal) {
        const handlers = [
          {
            on: 'keydown',
            key: $.ui.keyCode.ENTER,
            inEditor: true,
            run: (e) => {
              this.onEnterPressed(e);
            },
          },
          {
            on: 'keydown',
            key: $.ui.keyCode.ESCAPE,
            inEditor: true,
            run: () => {
              this.focused = false;
              this.activeRowIndex = null;
            },
          },
          {
            on: 'keydown',
            key: $.ui.keyCode.UP,
            inEditor: true,
            run: (e) => {
              e.preventDefault();
              this.arrowPressed(-1);
            },
          },
          {
            on: 'keydown',
            key: $.ui.keyCode.DOWN,
            inEditor: true,
            run: (e) => {
              e.preventDefault();
              this.arrowPressed(1);
            },
          },
        ];

        app.keyboardAccessibility.remove(app.KEYBOARD_LAYER.TLLB);
        app.keyboardAccessibility.add(app.KEYBOARD_LAYER.TLLB, handlers);
      } else {
        if (this.resetOnBlur) {
          this.tempValue = this.value;
        } else {
          const shouldSearch =
            _.isEmpty(this.tempValue) && !_.isEmpty(this.value);
          if (shouldSearch) {
            this.$emit('input', this.tempValue);
            this.$emit('search');
          }
        }
        this.$refs.input.blur();
        app.keyboardAccessibility.remove(app.KEYBOARD_LAYER.TLLB);
      }
    },
  },

  methods: {
    setFocus() {
      this.focused = true;
    },
    setBlur() {
      if (!this.focused) {
        return;
      }
      this.$nextTick(() => {
        this.focused = false;
        this.activeRowIndex = null;
      });
    },
    filterSuggestions(suggestions, numSuggestions, query) {
      const trim = (str) => str.replace(/["']/g, '').trim();
      if (_.isEmpty(query)) {
        return [];
      }
      const re = new RegExp('\\b' + app.escapeRegExpOperators(query), 'i');
      const results = _(suggestions)
        .filter((item) => re.exec(trim(item.text)))
        .uniq('text')
        .slice(0, numSuggestions)
        .value();
      return results;
    },
    clearTextBox(e) {
      this.tempValue = '';
      this.suggestionsFromServer = [];
      this.search({ text: '' }, e);
      this.$emit('clear');
      this.touched = false;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    onHoverOnOption(i) {
      this.activeRowIndex = i;
    },
  },

  components: {
    'wt-highlighted-ac-result': {
      template:
        '<li><div v-if="match" class="-inner">' +
        '<strong>{{left}}</strong>{{middle}}<strong>{{right}}</strong></div>' +
        '<div class="-inner" v-else>{{wholeText}}</div></li>',
      props: {
        highlight: {
          type: String,
          required: true,
        },
        wholeText: {
          type: String,
          required: true,
        },
      },

      created() {},

      watch: {
        highlight: {
          immediate: true,
          handler(newValue) {
            if (!newValue) {
              this.match = false;
              return;
            }
            const re = new RegExp(
              '^(.*)(' + app.escapeRegExpOperators(newValue) + ')(.*)$',
              'i'
            );
            const match = re.exec(this.wholeText);
            if (Array.isArray(match)) {
              this.match = true;
              this.left = match[1];
              this.middle = match[2];
              this.right = match[3];
            }
          },
        },
      },

      data() {
        return {
          match: false,
          left: '',
          right: '',
          middle: '',
        };
      },
    },
  },
};
</script>
